import React, { useState, useEffect, useCallback } from 'react';
import { Container, Grid, Typography, Button, Box, Card, CardMedia } from '@mui/material';
import Header from '../Components/header/Header'; // 引入 Header
import Footer from '../Components/footer/Footer'; // 引入 Footer

// 各分类的图片路径（WebP 格式）
const categories = {
  Melamine: [
    '/images/Melamine/Image_20241015222131.webp',
    '/images/Melamine/Image_20241015222249.webp',
    '/images/Melamine/Image_20241015223541.webp',
    '/images/Melamine/Image_20241015224645.webp',
    '/images/Melamine/Image_20241015224703.webp',
    '/images/Melamine/Image_20241015224735.webp',
    '/images/Melamine/Image_20241015224741.webp',
    '/images/Melamine/Image_20241015230924.webp',
    '/images/Melamine/Image_20241015230938.webp',
    '/images/Melamine/Image_20241015230943.webp',
  ],
  PET: [
    '/images/PET/Image_20241015231116.webp',
    '/images/PET/Image_20241015231120.webp',
    '/images/PET/Image_20241015231123.webp',
    '/images/PET/Image_20241015231126.webp',
    '/images/PET/Image_20241015231130.webp',
    '/images/PET/Image_20241015231134.webp',
    '/images/PET/Image_20241015231137.webp',
    '/images/PET/Image_20241015231141.webp',
    '/images/PET/Image_20241015231145.webp',
    '/images/PET/Image_20241015231148.webp',
  ],
  Thermofoil: [
    '/images/Thermofoil/Image_20241015231009.webp',
    '/images/Thermofoil/Image_20241015231014.webp',
    '/images/Thermofoil/Image_20241015231018.webp',
    '/images/Thermofoil/Image_20241015231022.webp',
    '/images/Thermofoil/Image_20241015231026.webp',
    '/images/Thermofoil/Image_20241015231030.webp',
    '/images/Thermofoil/Image_20241015231034.webp',
    '/images/Thermofoil/Image_20241015231038.webp',
    '/images/Thermofoil/Image_20241015231041.webp',
    '/images/Thermofoil/Image_20241015231050.webp',
  ],
};

// 预加载图片
const preloadImages = (images) => {
  images.forEach((image) => {
    const img = new Image();
    img.src = image;
  });
};

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('Melamine'); // 默认选择 Melamine

  // 预加载所有图片
  useEffect(() => {
    Object.values(categories).forEach((categoryImages) => preloadImages(categoryImages));
  }, []);

  const handleCategoryClick = useCallback((category) => {
    setSelectedCategory(category);
  }, []);

  return (
    <div
      style={{
        overflowX: 'hidden',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#ffffff', // 白色背景
      }}
    >
      {/* Header - 固定在页面顶部 */}
      <Header />

      {/* Gallery 内容 */}
      <Container
        maxWidth="lg"
        sx={{
          paddingTop: '80px', // 确保 Header 不会遮挡内容
          padding: '50px 0',
          flex: '1',
          backgroundColor: '#ffffff',
          borderRadius: '10px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Typography
          variant="h4"
          sx={{ textAlign: 'center', fontWeight: 'bold', marginBottom: '30px' }}
        >
          Gallery
        </Typography>

        {/* 分类选择按钮 */}
        <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
          {Object.keys(categories).map((category) => (
            <Button
              key={category}
              variant={selectedCategory === category ? 'contained' : 'outlined'}
              onClick={() => handleCategoryClick(category)}
              sx={{
                margin: '0 10px',
                backgroundColor: selectedCategory === category ? '#f97316' : 'white',
                color: selectedCategory === category ? 'white' : '#333',
                border: '1px solid #f97316',
                '&:hover': {
                  backgroundColor: '#f97316',
                  color: 'white',
                },
              }}
            >
              {category}
            </Button>
          ))}
        </Box>

        {/* 图片展示部分 */}
        <Grid container spacing={4}>
          {categories[selectedCategory].map((image, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                  '&:hover': {
                    transform: 'scale(1.05)',
                    transition: 'transform 0.3s ease-in-out',
                    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.2)',
                  },
                }}
              >
                <CardMedia
                  component="img"
                  image={image}
                  alt={`${selectedCategory} Image ${index + 1}`}
                  sx={{
                    width: '100%',
                    height: 300, // 统一高度
                    objectFit: 'cover',
                  }}
                />
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Gallery;